import { ApolloClient } from '@apollo/client'
import { slugs } from '@/constants/slugs'
import { GET_OUR_SHOWS } from '@/services/ProjectsService/queries'
import { ContentMovie, ContentSeries, GetOurShowsQuery } from '@/types/codegen-federation'

export type NowStreamingContent = ContentMovie | ContentSeries

export async function getNowStreamingProjects(client: ApolloClient<object>): Promise<NowStreamingContent[] | null> {
  const { data } = await client.query<GetOurShowsQuery>({
    query: GET_OUR_SHOWS,
    variables: {
      exclude: [
        slugs.insideAngelStudios,
        slugs.angelStudios,
        slugs.angelOldChosen,
        slugs.forYourConsideration,
        slugs.theChosen,
        slugs.stagingForContent,
        'jungle-beat-staging',
      ],
    },
    errorPolicy: 'all',
  })
  if (!data?.listWatchables?.edges) return []

  return data?.listWatchables?.edges
    .filter((edge) => {
      const watchableNode = edge?.node as ContentSeries | ContentMovie
      const project = watchableNode?.project
      const image = watchableNode.image

      return (
        Boolean(project?.slug) &&
        Boolean(image?.cloudinaryPath) &&
        Boolean(project.releaseDate) &&
        new Date(project.releaseDate).getTime() < new Date().getTime()
      )
    })
    .map((edge) => edge?.node as NowStreamingContent)
}
